
import {
  computed,
  defineComponent,
  // defineAsyncComponent,
  reactive,
  ref,
  toRefs,
  onUpdated,
  watch
} from 'vue'

import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import Size from '@/models/size'

import NavigationTab from '@/layouts/components/NavigationTab.vue'
import NavigationDropdownTab from '@/layouts/components/NavigationDropdownTab.vue'
import NavigationButtonGroup from '@/layouts/components/NavigationButtonGroup.vue'
import ViewButtonGroup, { View } from '@/components/ViewButtonGroup.vue'

import usePageUtil from '@/pages/composables/usePageUtil'
import { GLOBALS } from '@/constants'
import { useQuasar } from 'quasar'

export default defineComponent({
  name: 'PageFilter',
  components: { NavigationTab, NavigationDropdownTab, NavigationButtonGroup, ViewButtonGroup },
  props: {
    defaultView: {
      type: Boolean,
      default: false
    },
    isInsightsView: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const $q = useQuasar()
    const $store = useStore()
    const $route = useRoute()

    const {
      activeView,
      filters,
      activeViewName,
      showView,
      currentParent
    } = usePageUtil($route, __dirname)

    const state = reactive({
      cardsSelected: computed(
        () => $store.getters['View/ItemSize'] === Size.small
      ),
      hamburgerSelected: ref(false)
    })

    function onCardsClick () {
      $store.dispatch('View/ToggleItemSize').catch(console.error)
    }

    function onHamburgerClick () {
      // state.hamburgerSelected = !state.hamburgerSelected;
      // emit('onHamburgerClick', state.hamburgerSelected);
    }

    // onUpdated(() => {
    //   //
    // })


    const MAX_MENU_ITEMS = ref($q.screen.lt.md ? 3 : 5)
    watch(() => $q.screen.lt.md, (value) => {
      if (value) MAX_MENU_ITEMS.value = 3
      else MAX_MENU_ITEMS.value = 5
    })

    return {
      ...toRefs(state),
      MAX_MENU_ITEMS,
      hideNav: computed(() => $store.getters['App/HideMobileNav']),
      filtersHidden: computed(() => $store.getters['App/HideFilters']),
      activeView,
      currentParent,
      filters,
      activeViewName,
      showView,
      onCardsClick,
      onHamburgerClick,
      isMobile: computed(() => $q.screen.lt.sm),
      GLOBALS,
      showFilters: ref(false)
    }
  }
})
